import { useEffect, useState } from 'react';
import { Modal } from '../../../theme/Component/Modal';
import { FunctionalAreeaStateEditor } from './FunctionalAreeaState.editor';
import { SelectFunctionalID } from '../functionalID/SelectFunctionalID';
import { AppointmentEditor } from '../../../Talentohumano/ParametrosTalentoHumano/Appointment/Appointment.editor';
import { ConstractStateEditor } from '../../../Talentohumano/GestionTH/EmployeeContract/ComponentsContract/EditorsEmployeContrac/ConstractState.editor';
import { BasicButton } from '../../../theme/Component/BasicButton';
import { BasicTable, MASK_DATE, MASK_NUMBER } from '../../../theme/Component/BasicTable';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _FunctionalArea, _single } from '../../../../core/services/dataBean/EntityCatalog';
import { Singleton } from '../../../../core/services/Singleton';
import { SelectSiteID } from '../SiteID/SelectSiteID';
import { AppointmentGroupManualEditor } from '../../../Talentohumano/ParametrosTalentoHumano/AppointmentGroupManual/AppointmentGroupManual.editor';
import { AppointmentManualEditor } from '../../../Talentohumano/ParametrosTalentoHumano/AppointmentManual/AppointmentManual.editor';
import { ARPRiskEditor } from '../../../Talentohumano/GestionTH/EmployeeContract/ComponentsContract/EditorsEmployeContrac/ARPRisk.editor';
import { EmploymentTypeEditor } from '../../../Talentohumano/GestionTH/EmployeeContract/ComponentsContract/EditorsEmployeContrac/EmploymentType.editor';
import { EmployeeContractTypeEditor } from '../../../Talentohumano/GestionTH/EmployeeContract/ComponentsContract/EditorsEmployeContrac/EmployeeContractType.editor';
import { CostingCenterSelect } from '../../../erp/cellEditor/CostingCenter/CostingCenterSelect';
import usePaginator from '../../../theme/Component/usePaginator';
import { AccountEditor } from '../../../editor/AccountEditor';
import { MODAL_XL } from '../../../theme/Component/hooks/useModal';
import { InputDate } from '../../../theme/Input/InputDate';
import { toast } from 'react-toastify';

interface Props {
    label?: string;
    onChange: Function;
    value?: number;
    disable?: boolean;
}
export const SelectFunctionalArea = ({ onChange, label, value, disable }: Props) => {

    const [modal, setModal] = useState<any>({ name: 'Plazas Laborales', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: MODAL_XL });
    const [modalUpdate, setModalUpdate] = useState<any>({ name: 'Crear Plaza Laboral', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [lista, setLista] = useState<any>([]);
    const paginador = usePaginator();
    const [date, setdate] = useState<any>(null);
    const single = Singleton.getInstance();
    const functionalArea = useDataBean(_FunctionalArea);
    const [state, setState] = useState<number>(3);
    const [contracState, setcontracState] = useState<number>(null);
    const [appointment, setAppointment] = useState<number>(null);
    const [funtional, setFuntional] = useState<number>(null);
    const [name, setName] = useState<string>(null);
    const [objectLn, setObjectLn] = useState<any>({});
    const [group, setGroup] = useState<number>(null);
    const [IDLn, setIDLn] = useState<any>(null);
    const [funcionario, setFuncionario] = useState<number>(null);

    useEffect(() => {
        if (value !== objectLn.IDLn && value) {
            functionalArea.instance.getFunctionalArea(value).then(
                (resp) => {
                    setObjectLn(resp)
                    onChange(resp)
                }
            ).catch(
                err => { toast.error("no se encontro la plaza") }
            )
        }
    }, [value])


    useEffect(() => {
        if (paginador.page > 0) {
            setdate(_single.getCurrenDate())
            getLista();
        }
    }, [paginador.page])

    const getLista = () => {
        functionalArea.instance.getFunctionalAreaCatalogvdos(IDLn, state, name, funtional, appointment, contracState, funcionario, date, paginador.page, 15).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                paginador.setRegiPerPage(15)

                setLista(resp.List.reverse())
            }
        )
    }


    const getItem = () => {

        onChange(objectLn)
        setModal({ ...modal, "view": false });
    }

    const editaItem = () => {
        let x = functionalArea.bean;
        x.IDEmployeeLastUpdate = single.getAccountID();
        //console.log(x)
        functionalArea.update().then(
            (resp) => {
                //console.log(resp)
                getLista()
                setModalUpdate({ ...modalUpdate, "view": false })
            }
        )
    }

    const create = () => {
        functionalArea.setBean({
            State: 3,
        })
        setModalUpdate({ ...modalUpdate, "name": "Agregar Plaza Laboral", "view": true })
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const head = [
        { title: 'ID', property: 'IDLn', mask: MASK_NUMBER, visible: true },
        { title: 'Estado de la Plaza', property: 'StateName', visible: true },
        { title: 'Tipo de Labor', property: 'LabourTypeName', visible: true },
        { title: 'Código', property: 'Code', mask: MASK_NUMBER, visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: false },
        { title: 'Nivel Jerárquico', property: 'EntailmentName', visible: false },
        { title: 'Nivel Salarial', property: 'AppointmentName', visible: true },
        { title: 'Ubicación Geográfica de la Plaza', property: 'SiteIDName', visible: false },
        { title: 'Manual de Perfil y Funciones del Cargo', property: 'AppointmentManualName', visible: false },
        { title: 'Centro de Costo', property: 'CostingCenterName', visible: false },
        { title: 'Área de Negocio', property: 'BusinessCoreName', visible: false },
        { title: 'Riesgo Laboral', property: 'ARPRiskName', visible: false },
        { title: 'Unidad Organizacional', property: 'FunctionalIDName', visible: false },
        { title: 'Codigo Área', property: 'FunctionalIDCode', visible: true },
        { title: 'Área', property: 'FunctionalIDName', visible: true },
        { title: 'IDContrato Laboral', property: 'IDContract', mask: MASK_NUMBER, visible: true },
        { title: 'Empleado', property: 'FunctionalAreaName', visible: false },
        { title: 'Empleado', property: 'AccountName', visible: true },
        { title: 'Titular Plaza', property: 'AccountHolderName', visible: true },
        { title: 'Fecha Inicio', property: 'InitContract', visible: true },
        { title: 'Fin del Contrato', property: 'UptoContract', visible: false },
        { title: 'Estado del Contrato', property: 'ContractStateName', visible: true },
        { title: 'Creado por', property: 'EmployeeName', visible: false },
        { title: 'Fecha de Creación', property: 'Since', mask: MASK_DATE, visible: true },
        { title: 'Última actualización', property: 'LastUpdateEmployeeName', visible: true },
        { title: 'Fecha Última Actualización', property: 'LastUpdate', visible: true },
    ]

    return (
        <>
            <label>{label ?? "Plaza Laboral"}</label>
            <span
                className={`form-control text-wrap ${disable ? "bg-light text-muted" : ""}`}
                style={{
                    minHeight: "35px",
                    cursor: disable ? "not-allowed" : "pointer"
                }}
                onClick={() => {
                    if (!disable) {
                        setModal({ ...modal, view: true });
                    }
                }}
                aria-disabled={disable}
            >
                {objectLn.IDLn
                    ? `${objectLn.IDLn} - ${objectLn.Name}`
                    : "Seleccione una Plaza"}
            </span>

            {modal.view &&
                <Modal modal={modal} updateModal={setModal} eventModal={getItem} onSubmitLabel='Seleccionar'>
                    <>
                        <div className="row">
                            <div className="col-4">
                                <label>ID de Plaza Laboral</label>
                                <input type="text" className="form-control" value={IDLn} onChange={(e) => { setIDLn(e.target.value) }} />
                            </div>
                            <div className="col-4">
                                <FunctionalAreeaStateEditor label="Estado" idSelector={state} onChange={(e) => { setState(e) }} />
                            </div>
                            <div className="col-4">
                                <label>Nombre de la plaza</label>
                                <input type="text" className="form-control" value={name} onChange={(e) => { setName(e.target.value) }} />
                            </div>
                            <div className="col-md-4">
                                <InputDate name="date" label="Fecha a consultar" value={date} setDate={(e: any) => { setdate(e) }} />
                            </div>
                            <div className="col-4">
                                <SelectFunctionalID label="Unidad Organizacional" onChange={(e) => { setFuntional(e?.IDLn) }} />
                            </div>
                            <div className="col-4">
                                <AppointmentEditor label="Nivel Salarial" idSelector={appointment} onChange={(e) => { setAppointment(e) }} />
                            </div>
                            <div className="col-4">
                                <ConstractStateEditor idSelector={contracState} onChange={(e) => { setcontracState(e) }} />
                            </div>
                            <div className="col-md-4">
                                <AccountEditor idAccount={funcionario} onChange={(e) => { setFuncionario(e.IDAccount) }} label="Tercero" />
                            </div>
                            <div className="col-12">
                                <BasicButton icon="" eventClick={getLista}>Buscar</BasicButton>
                            </div>
                        </div>
                        <BasicTable
                            // iconButtons={iconButtonsItem} 
                            body={lista} head={head} rowSet={setObjectLn} records={paginador} />

                        {modal.view &&
                            <Modal modal={modalUpdate} updateModal={setModalUpdate} eventModal={editaItem} >
                                <div className="row">
                                    <div className="col-6">
                                        <label>Código</label>
                                        <input type="number" name="Code" className="form-control" value={functionalArea.bean.Code} onChange={functionalArea.handleChange} />
                                    </div>
                                    <div className="col-6">
                                        <label>Nombre</label>
                                        <input type="text" name="Name" className="form-control" value={functionalArea.bean.Name} onChange={functionalArea.handleChange} />
                                    </div>
                                    <div className="col-12">
                                        <label>Descripción</label>
                                        <textarea name="Description" className="form-control" value={functionalArea.bean.Description} onChange={functionalArea.handleChange} />
                                    </div>
                                    <div className="col-6">
                                        <AppointmentEditor idSelector={functionalArea.bean.IDAppointment} onChange={(e) => { functionalArea.setBean({ ...functionalArea.bean, "IDAppointment": e }) }} />
                                    </div>
                                    <div className="col-6">
                                        <SelectSiteID edit idLnSite={functionalArea.bean.IDLnSiteID} onChange={(e) => { functionalArea.setBean({ ...functionalArea.bean, "IDLnSiteID": e.IDLn }) }} />
                                    </div>
                                    <div className="col-6">
                                        <AppointmentGroupManualEditor idSelector={group} onChange={(e) => { setGroup(e) }} />
                                    </div>
                                    <div className="col-6">
                                        <AppointmentManualEditor appoGroup={group} idSelector={functionalArea.bean.IDAppointmentManual} onChange={(e) => { functionalArea.setBean({ ...functionalArea.bean, "IDAppointmentManual": e }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <CostingCenterSelect label="Centro de Costo" idSelector={functionalArea.bean.CostingCenterCode} onChange={(e) => { functionalArea.setBean({ ...functionalArea.bean, "CostingCenterCode": e }) }} />
                                    </div>
                                    <div className="col-6">
                                        <SelectFunctionalID functionalIDLn={functionalArea.bean.IDLnFunctionalID} onChange={(e) => { functionalArea.setBean({ ...functionalArea.bean, "IDLnFunctionalID": e?.IDLn }) }} />
                                    </div>
                                    <div className="col-6">
                                        <ARPRiskEditor idSelector={functionalArea.bean.ARPRisk} onChange={(e) => { functionalArea.setBean({ ...functionalArea.bean, "ARPRisk": e }) }} />
                                    </div>
                                    <div className="col-6">
                                        <EmploymentTypeEditor idSelector={functionalArea.bean.IDEmploymentType} onChange={(e) => { functionalArea.setBean({ ...functionalArea.bean, "IDEmploymentType": e }) }} />
                                    </div>
                                    <div className="col-6">
                                        <EmployeeContractTypeEditor idSelector={functionalArea.bean.IDEmployeeContractType} onChange={(e) => { functionalArea.setBean({ ...functionalArea.bean, "IDEmployeeContractType": e }) }} />
                                    </div>
                                    {/* <PrintJson json={functionalArea.bean} /> */}
                                </div>
                            </Modal>
                        }
                    </>
                </Modal >
            }


        </>
    )
}